import { Dialog, SwipeableDrawer } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  SmartLearningModalDeleteContent,
  SmartLearningModalEditContent
} from "../../components";

type AgendaActionModalProps = {
  action: string
  actionDate: Date
  actionEnd: string
  actionId: number
  actionStart: string
  isMobile: boolean
  isOpen: boolean
  setIsOpen: (open: boolean) => void
}

export function AgendaActionModal({
  action,
  actionDate,
  actionEnd,
  actionId,
  actionStart,
  isMobile,
  isOpen,
  setIsOpen
}: AgendaActionModalProps) {
  const theme = useTheme();

  const content = action == "modify" ?
    <SmartLearningModalEditContent
      onClose={ () => setIsOpen(false) }
      selectedDate={ actionDate }
      slotId={ actionId }
      start={ actionStart }
      end={ actionEnd }
    /> :
    <SmartLearningModalDeleteContent
      onClose={ () => setIsOpen(false) }
      slotId={ actionId }
    />;

  return isMobile ? (
    <SwipeableDrawer
      anchor={ "bottom" }
      open={ isOpen }
      disablePortal={ true }
      onClose={ () => setIsOpen(false) }
      onOpen={ () => setIsOpen(true) }
      className={ "smart-drawer" }
      sx={ {
        "& .MuiModal-backdrop": {
          bottom: "60px"
        },

        "& .MuiPaper-root" : {
          background: theme.linearGradients.backgroundCard,
          border: `2px solid ${theme.customColors.border}`,
          borderColor: theme.customColors.borderAccent,
          borderRadius: "8px 8px 0 0",
          bottom: "60px",
          padding: "16px 20px",
          transition: "none",

          [theme.breakpoints.down("sm")]:{
            height: "calc(100% - 120px)"
          }
        }
      } }
    >
      { content }
    </SwipeableDrawer>
  ) : (
    <Dialog
      // il titolo è reso dal contenuto (Edit/Delete) in tutti i suoi stati con questi id
      aria-labelledby={ action == "modify" ? "title-to-announce-edit" : "title-to-announce-delete" }
      maxWidth={ false }
      open={ isOpen }
      onClose={ (event, reason) => {
        if(reason == "backdropClick" || reason == "escapeKeyDown") {
          return;
        }
        setIsOpen(false);
      } }
      scroll={ "paper" }
      sx={ {
        ".MuiDialog-paper ": {
          "&:hover": {
            border: `2px solid ${theme.customColors.borderAccent}`
          },
          background: theme.customColors.backgroundCard,
          border: `2px solid ${theme.customColors.border}`,
          borderRadius:"0.5rem",
          bottom: "10%",
          padding: "1.5rem"
        }
      } }
    >
      { content }
    </Dialog>
  );
}
